// Win screen
import { SFX } from '../core/audio';
import { $ } from './dom';
import { G, LEVELS, payLocked } from './state';
import { I, setI } from './icons';
import { updateHud } from './hud';
import { rebuild, loadLevel } from './play';
import { openMap } from './map';
import { openCredits } from './credits';
import { openLock } from './gate';

// ---------- Win ----------
export function showWin(stars: number, used: number) {
  const ws = $('#winStars'); ws.innerHTML = I.star + I.star + I.star;
  [...ws.children].forEach((el, i) => setTimeout(() => { if (i < stars) { el.classList.add('on'); SFX.play('star', i); } }, 250 + i * 300));
  const pc = $('#winParts');
  pc.innerHTML = `<span class="pc">${Array.from({ length: used }, () => '<i></i>').join('')}</span>` + (G.S.duckGot ? '<span style="font-size:34px">🦆</span>' : '');
  const next = G.li + 1 < LEVELS.length;
  $('#winNext').hidden = !next;
  $('#winCredits').hidden = next;
  $('#ovWin').hidden = false;
}
setI($('#winMap'), 'map'); setI($('#winRetry'), 'retry'); setI($('#winNext'), 'next');
$('#winMap').addEventListener('click', () => { SFX.play('click'); $('#ovWin').hidden = true; openMap(); });
$('#winRetry').addEventListener('click', () => { SFX.play('click'); $('#ovWin').hidden = true; G.state = 'build'; G.fx = []; rebuild(); updateHud(); });
$('#winNext').addEventListener('click', () => {
  SFX.play('click'); $('#ovWin').hidden = true;
  const n = G.li + 1;
  if (payLocked(n)) { openMap(); openLock(); return; }
  loadLevel(n);
});
setI($('#winCredits'), 'star');
$('#winCredits').addEventListener('click', () => { SFX.play('click'); $('#ovWin').hidden = true; openCredits(); });
